export default function Footer() {
  return (
    <footer id="footer" className="bg-background-50 pt-4 px-4 md:px-6 pb-0">
      <div className="max-w-[1440px] mx-auto bg-background-200 rounded-[32px] px-8 md:px-16 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr_1.5fr] gap-12 md:gap-16">
          <div>
            <h3 className="text-2xl font-heading font-bold text-foreground-50 mb-3">
              订阅每日鲜瓜
            </h3>
            <p className="text-sm text-foreground-400 mb-6 leading-relaxed">
              第一时间获取全网最新吃瓜爆料，不错过任何一个塌房现场。
            </p>
            <div className="flex flex-col sm:flex-row items-stretch sm:items-end gap-3">
              <div className="flex-1 border-b border-foreground-400/30 pb-2">
                <input
                  type="email"
                  placeholder="输入你的邮箱地址"
                  className="w-full bg-transparent text-sm text-foreground-100 placeholder-foreground-500 outline-none"
                />
              </div>
              <button className="px-6 py-2.5 rounded-full bg-accent-500 text-background-950 font-bold text-sm hover:bg-accent-400 transition-all duration-200 whitespace-nowrap cursor-pointer">
                订阅
                <i className="ri-arrow-right-line ml-1.5"></i>
              </button>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-bold text-foreground-400 uppercase tracking-wider mb-5">
              导航链接
            </h4>
            <div className="flex flex-col gap-3">
              <a href="#faq" className="text-sm text-foreground-300 hover:text-accent-500 transition-colors duration-200 underline underline-offset-4 whitespace-nowrap">
                爆料问答
              </a>
              <a href="#about" className="text-sm text-foreground-300 hover:text-accent-500 transition-colors duration-200 underline underline-offset-4 whitespace-nowrap">
                平台简介
              </a>
              <a href="#app" className="text-sm text-foreground-300 hover:text-accent-500 transition-colors duration-200 underline underline-offset-4 whitespace-nowrap">
                APP下载
              </a>
              <a href="#contact" className="text-sm text-foreground-300 hover:text-accent-500 transition-colors duration-200 underline underline-offset-4 whitespace-nowrap">
                投稿爆料
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-bold text-foreground-400 uppercase tracking-wider mb-5">
              联系我们
            </h4>
            <div className="flex flex-col gap-2 mb-6">
              <p className="text-sm text-foreground-300">📧 wuyichigua@email.com</p>
              <p className="text-sm text-foreground-300">📞 400-888-5151</p>
            </div>
            <h4 className="text-xs font-bold text-foreground-400 uppercase tracking-wider mb-2">
              地址
            </h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              北京市朝阳区望京SOHO<br />T1-A座 2018室
            </p>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-foreground-400/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-foreground-400 hover:text-accent-500 transition-colors duration-200 underline underline-offset-4 whitespace-nowrap">
              微博
            </a>
            <a href="#" className="text-sm text-foreground-400 hover:text-accent-500 transition-colors duration-200 underline underline-offset-4 whitespace-nowrap">
              抖音
            </a>
            <a href="#" className="text-sm text-foreground-400 hover:text-accent-500 transition-colors duration-200 underline underline-offset-4 whitespace-nowrap">
              小红书
            </a>
          </div>
          <p className="text-xs text-foreground-500 text-center">
            © 2026 五一吃瓜网 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200 underline underline-offset-4 whitespace-nowrap">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200 underline underline-offset-4 whitespace-nowrap">
              用户协议
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}